'use client'

import { useCallback, useMemo } from 'react'
import { Image } from '@/components/v2/atoms/image/image'
import cx from 'classnames'
import s from './hero.module.css'

type HeroProps = {
  content: React.ReactNode
  imageSrc: string
  imageAlt: string
  imageChipText?: string
  contentFrameBgColor?: string
  shorterMobileImage?: boolean
  shorterContent?: boolean
  reverse?: boolean
  onImageClickCb?: () => void
}

const Hero: React.FC<HeroProps> = ({
  content,
  imageChipText,
  imageSrc,
  imageAlt,
  contentFrameBgColor,
  reverse = false,
  shorterMobileImage = false,
  shorterContent = false,
  onImageClickCb,
}) => {
  const imageCallbacks = useMemo(() => !!onImageClickCb, [onImageClickCb])
  const handleOnClickImage = useCallback(() => {
    if (onImageClickCb) {
      onImageClickCb()
    }
  }, [onImageClickCb])

  return (
    <div
      className={cx(s.heroContainer, {
        [s.reverse]: reverse,
      })}
    >
      <div
        className={s.heroCardContainer}
        style={{ backgroundColor: contentFrameBgColor || '#F5F5F6' }}
      >
        <div
          className={cx(s.heroContent, {
            [s.shorterContent]: shorterContent,
            [s.reverse]: reverse,
          })}
        >
          {content}
        </div>
      </div>
      <div
        onClick={handleOnClickImage}
        className={cx(s.imageContainer, {
          [s.pointer]: !!imageCallbacks,
        })}
      >
        <Image
          className={cx(s.heroImage, {
            [s.shorterMobileImage]: shorterMobileImage,
          })}
          src={imageSrc}
          alt={imageAlt}
          width={1000}
          height={1000}
          fit
        />
        {imageChipText && (
          <div
            className={cx(s.imageChip, {
              [s.reverse]: reverse,
            })}
          >
            {imageChipText}
          </div>
        )}
      </div>
    </div>
  )
}

export default Hero
